import { axiosClient } from "../axios";
import { getQuery } from "../helper";

const baseUrl = "/api/registry";

export function getRootUsers(params) {
  const query = getQuery(params);
  return axiosClient.get(`${baseUrl}/users/root`, query);
}

export function registerRootUser(data) {
  return axiosClient.post(`${baseUrl}/users/root`, data);
}
